import React, { useState, useEffect } from "react"

// Hooks
import { useMovieFetch } from "../../hooks/useMovieFetch"
import { useTvShowFetch } from "../../hooks/useTvShowFetch"
import { useTopMovieFetch } from "../../hooks/useTopMovieFetch"
// My Component
import { Page, Breadcrumb, ViewAll, Card, Button, Spiner } from "../../components"
import { POSTER_SIZE, IMAGE_BASE_URL } from "../../helpers/config"

function All() {
  const [title, setTitle] = useState("")
  const [movies, dispatch] = useMovieFetch()
  const [tv, dispatchTv] = useTvShowFetch()
  const [tops, topDispatch] = useTopMovieFetch()
  const [isLoading, setLoading] = useState(false)

  let page = document.location.pathname

  useEffect(() => {
    if (page === "/popular-movies") {
      setTitle("Popular Movies")
    } else if (page === "/tv-shows") {
      setTitle("Popular Tv Shows")
    } else if (page === "/top-rated-movies") {
      setTitle("Top Rating Movies")
    }
  }, [page])

  function loadMore() {
    if (page === "/popular-movies") {
      dispatch({ type: "loadMore" })
    } else if (page === "/tv-shows") {
      dispatchTv({ type: "loadMore" })
    } else if (page === "/top-rated-movies") {
      setTitle("Top Rating Movies")
      topDispatch({ type: "loadMore" })
    }
    setLoading(true)
  }

  useEffect(() => {
    setLoading(false)
  }, [movies, tv, tops])

  return (
    <Page title={title} disc={`Best of ${title}`}>
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item title={title} />
        </Breadcrumb.List>
      </Breadcrumb>
      <ViewAll>
        <ViewAll.Title>{title}</ViewAll.Title>
        <ViewAll.Body>
          {page === "/popular-movies" &&
            Boolean(movies.length) &&
            movies.map((movie) => {
              return (
                <Card key={movie.id} to={`movie/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : ""} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.title}</Card.Title>
                    <Card.Date>{movie.release_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}
          {page === "/tv-shows" &&
            Boolean(tv.length) &&
            tv.map((movie) => {
              return (
                <Card key={movie.id} to={`tv/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : ""} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.name}</Card.Title>
                    <Card.Date>{movie.first_air_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}

          {page === "/top-rated-movies" &&
            Boolean(tops.length) &&
            tops.map((movie) => {
              return (
                <Card key={movie.id} to={`movie/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : ""} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.title}</Card.Title>
                    <Card.Date>{movie.release_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}
        </ViewAll.Body>
        <ViewAll.More>{isLoading ? <Spiner /> : <Button.LoadMore onClick={loadMore}>Load More</Button.LoadMore>}</ViewAll.More>
      </ViewAll>
    </Page>
  )
}

export default All
